import React, { useState, useEffect, useContext } from 'react';
import Loading from '../Loading';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation, useHistory } from "react-router-dom";
import ScheduleBox from './ScheduleBox';
import { scheduleEmailsGet, scheduleSmsGet } from '../../api';
import { somethingWentWrongNotice } from '../UI/Notifications';
import { UserContext } from 'context/User';

const ScheduleTemplateView = ({ setTrigger, trigger }) => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const query = useQuery();
  const id = query.get("template_id");
  const type = query.get("type");
  const [loading, setLoading] = useState(false);
  const [messageInfo, setMessageInfo] = useState({});
  const history = useHistory();
  const title = type === 'sms' && 'Scheduled SMS' || type === 'email' && 'Scheduled Email'; 

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Something went wrong");
    }
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    switch (type) {
      case 'email':
        scheduleEmailRequest()
        break;
      case 'sms':
        scheduleSmsRequest()
        break;
      default:
        setLoading(false);
    }
    setTrigger(!trigger);
  }, []);

  const scheduleEmailRequest = () => {
    scheduleEmailsGet(id)
      .then(response => {
        setMessageInfo(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  const scheduleSmsRequest = () => {
    scheduleSmsGet(id)
      .then(response => {
        setMessageInfo(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              {title}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <ScheduleBox 
              messageInfo={messageInfo}
              type={type}
              handleDefaultStatusCodes={handleDefaultStatusCodes}
              setLoading={setLoading}
            />
          </Col>
        </Row>
      </Container>
      {loading && <Loading />}
    </section>  
  )
}

export default ScheduleTemplateView;